import { c as _c } from "react/compiler-runtime";
import React from 'react';
const NotAuthorisedIcon = props => {
  const $ = _c(22);
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Not authorized icon</title>;
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M109.819 10.6895L150.814 6.99996L152.072 20.9779L142.539 21.8358L174.298 27.7449L171.741 41.4871L131.438 33.9883L133.549 22.645L119.947 23.8691H128.695V37.8471H87.7002V23.8691H111.006L109.819 10.6895ZM173.366 57.2305H132.372V71.2085H173.366V57.2305ZM218.037 90.5801H177.043V104.558H218.037V90.5801ZM43.04 123.941H84.0344V137.919H43.04V123.941ZM128.695 123.941H87.7002V137.919H128.695V123.941ZM132.372 123.941H173.366V137.919H132.372V123.941ZM177.043 123.941H218.037V137.919H177.043V123.941ZM132.372 90.5801H173.366V104.558H132.372V90.5801ZM128.695 90.5801H87.7002V104.558H128.695V90.5801ZM43.04 90.5801H84.0344V104.558H43.04V90.5801ZM87.7002 57.2305H128.695V71.2085H87.7002V57.2305ZM195.696 107.262H154.702V121.24H195.696V107.262ZM110.042 107.262H151.036V121.24H110.042V107.262ZM106.365 107.262H65.3701V121.24H106.365V107.262ZM21 107.262H61.9944V121.24H21V107.262ZM195.696 73.9004H154.702V87.8784H195.696V73.9004ZM110.042 73.9004H151.036V87.8784H110.042V73.9004ZM106.365 73.9004H65.3701V87.8784H106.365V73.9004ZM110.042 40.5488H151.036V54.5269H110.042V40.5488ZM106.365 40.5488H65.3701V54.5269H106.365V40.5488Z" fill="#111827" fillOpacity="0.06" />;
    t2 = <rect x="70.6348" y="64" width="9.43903" height="86" fill="#9CA3AF" />;
    t3 = <rect x="77.9766" y="64" width="2.09756" height="86" fill="#111827" fillOpacity="0.06" />;
    t4 = <rect x="159.781" y="64" width="9.43903" height="86" fill="#9CA3AF" />;
    t5 = <rect x="167.121" y="64" width="2.09756" height="86" fill="#111827" fillOpacity="0.06" />;
    t6 = <path d="M182.853 105.945H57V124.823H182.853V105.945Z" fill="#F3F4F6" />;
    t7 = <path d="M117.595 105.945L96.0937 124.823H80.6255L102.125 105.945H117.595Z" fill="#6366F1" />;
    t8 = <path d="M87.2019 105.945L65.7004 124.823H57V118.881L71.7336 105.945H87.2019Z" fill="#6366F1" />;
    t9 = <path d="M132.473 105.945L110.972 124.823H126.44L147.941 105.945H132.473Z" fill="#6366F1" />;
    t10 = <path d="M178.291 105.945L156.792 124.823H141.321L162.823 105.945H178.291Z" fill="#6366F1" />;
    t11 = <path d="M182.854 115.002V124.818H171.672L182.854 115.002Z" fill="#6366F1" />;
    t12 = <rect x="57" y="122.727" width="125.853" height="2.09756" fill="#111827" fillOpacity="0.06" />;
    t13 = <path d="M182.853 74.4922H57V93.3685H182.853V74.4922Z" fill="#F3F4F6" />;
    t14 = <path d="M117.595 74.4922L96.0937 93.3702H80.6255L102.125 74.4922H117.595Z" fill="#6366F1" />;
    t15 = <path d="M87.2019 74.4922L65.7004 93.3702H57V87.4274L71.7336 74.4922H87.2019Z" fill="#6366F1" />;
    t16 = <path d="M132.473 74.4922L110.972 93.3702H126.44L147.941 74.4922H132.473Z" fill="#6366F1" />;
    t17 = <path d="M178.291 74.4922L156.792 93.3702H141.321L162.823 74.4922H178.291Z" fill="#6366F1" />;
    t18 = <path d="M182.854 83.5508V93.369H171.672L182.854 83.5508Z" fill="#6366F1" />;
    t19 = <rect x="57" y="91.2656" width="125.853" height="2.09756" fill="#111827" fillOpacity="0.06" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t15;
    $[8] = t16;
    $[9] = t17;
    $[10] = t18;
    $[11] = t19;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t15 = $[7];
    t16 = $[8];
    t17 = $[9];
    t18 = $[10];
    t19 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t20;
  if ($[20] !== props) {
    t20 = <svg xmlns="http://www.w3.org/2000/svg" width="240" height="160" viewBox="0 0 240 160" fill="none" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}</svg>;
    $[20] = props;
    $[21] = t20;
  } else {
    t20 = $[21];
  }
  return t20;
};
export default NotAuthorisedIcon;